import React, { useContext, useState, useEffect } from "react";
import { GlobalContext } from "../../../../context/Provider";
import {
  Box,
  Tabs,
  Tab,
  Typography,
} from "@mui/material";
import Profile from "../../../PatientBoard/microViews/Profile/Profile";
import Details from "../../../PatientBoard/microViews/Details/Details";
import ManageCoords from "../../../PatientBoard/microViews/ManageCoords/ManageCoords";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export interface EditProps {
  type: "coordinator" | "member" | "archived";
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
      style={{ width: "100%" }}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`
  };
}

export default function Edit(props: EditProps) {
  const { member, provider, memberDispatch, encounterTimer, encounterTimerDispatch } = useContext(GlobalContext);
  const [value, setValue] = useState(0);
  const memberId = member?.current?.id;

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  useEffect(() => {
    encounterTimerDispatch({
      type: "START_ENCOUNTER",
      payload: {
        current: {
          memberId,
          actions: [],
          duration: 0,
          escalatedDuration: 0,
          pause: false
        }
      }
    });

    return () => {
      encounterTimerDispatch({ type: "RESET_ENCOUNTER_TIMER" });
    };
  }, [memberId]);

  useEffect(() => {
    const timer = encounterTimer?.current;
    if(!timer) return;
    if (timer.pause) return;
    const interval = setInterval(() => {
      timer.duration += 1;
    }, 1000);
    return () => clearInterval(interval);
  }, [
    encounterTimer?.current?.memberId,
    encounterTimer?.current?.pause
  ]);

  return (
    <>
      <Box
        sx={{
          overflow: "auto",
          position: "fixed",
          top: 160,
          bottom: 68,
          left: 120,
          right: 125,
          bgcolor: "background.paper"
        }}
      >
        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={value}
          onChange={handleChange}
          aria-label="Vertical tabs example"
          sx={{
            borderRight: 1,
            borderColor: "divider",
            alignItems: "flex-start"
          }}
        >
          <Tab label="Profile" {...a11yProps(0)} />
          {props.type === "member" && <Tab label="Details" {...a11yProps(1)} />}
            <Tab
              label={`Manage ${props.type !== 'member' ? 'Members' : "Coordinators"}`}
              {...a11yProps(props.type !== 'member' ? 1 : 2)}
            />
        </Tabs>
        <TabPanel value={value} index={member?.current ? 0 : 0}>
          <Profile
            type={props.type === "member" ? "members" : "coordinator"}
            action="edit"
            isAvatar={false}
            memberId={memberId ?? ""}
          />
        </TabPanel>
        {props.type === "member" && (
          <TabPanel value={value} index={1}>
            <Details
              type={props.type}
              action="edit"
              memberId={memberId ?? ""}
            />
          </TabPanel>
        )}
          <TabPanel
            value={value}
            index={props.type !== 'member' ?  1 : 2}
          >
            <ManageCoords
              type={props.type}
              memberId={memberId ?? ""}
            />
          </TabPanel>       
      </Box>
    </>
  );
}
